<ion-row [ngClass]="disabled ? 'disabled' : '' ">
    <!-- <ion-row [hidden]="totalItems==0"> -->


    <ion-col size="12" sizeMd="8" pushMd="4" class="ion-justify-content-end ion-align-items-center">

        <ng-container *ngIf="Pages?.length > 0 && totalItems > itemsForPageSelected">

            <ion-button color="light" [disabled]="page<=1 || disabled" (click)="PreviousPage()">
                <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
            </ion-button>

            <ng-container *ngFor="let item of Pages">
                <ion-button [disabled]="disabled"
                    [hidden]="!(item === 1 || item === Pages.length || (item >= (page==Pages.length ? (page-2) : (page-1))) && (item <= (page==1 ? (page+2): (page+1))))"
                    [color]="item==page ? 'primary': 'light'" (click)="GoPage(item)">{{item}}</ion-button>
            </ng-container>

            <ion-button color="light" [disabled]="page>=Pages.length || disabled" (click)="NextPage()">
                <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
            </ion-button>

        </ng-container>

    </ion-col>

    <ion-col size="12" sizeMd="4" pullMd="8" class="ion-justify-content-start ion-align-items-start">

        <!-- *ngIf="(totalItems>itemsPerPage[0])" -->
        <ion-item>
            <ion-label>
                <ion-text>Registos por página:</ion-text>
                <p><b>Total</b>: {{totalItems}}</p>
            </ion-label>
            <app-select-search [disabled]="disabled" [value]="itemsForPageSelected" [interface]="'popover'"
                (ionChange)="CalcNumberPages($event)">
                <app-select-search-option *ngFor="let item of itemsPerPage" [value]="item">{{item}}</app-select-search-option>
            </app-select-search>
        </ion-item>

    </ion-col>
</ion-row>